// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.viewH3 {
  font-size: 24px;
  font-family: inherit;
  font-weight: 500;
  line-height: 1.1;
  color: inherit;
  margin-top: 70px;
  margin-bottom: 20px;
  color: #797979;
}

.viewH3 .viewH3Arrow {
  font-size: 16px;
}

.viewContainer {
  background: #ffffff;
  padding: 15px;
  margin-bottom: 15px;
  box-sizing: border-box;
  color: #797979;
  font-family: "Ruda", sans-serif;
  font-size: 13px;
  box-shadow: 3px 3px 3px 3px #aab2bd;
  margin-left: 15%;
  margin-right: 15%;
}

.viewSearch {
  color: #fff;
  background-color: #68dff0;
  box-shadow: inset 0 3px 5px rgb(0 0 0 / 13%);
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  border: 1px solid #48bcb4;
  border-radius: 4px;
  cursor: pointer;
}
.viewSearch:hover {
  background-color: #51cac2;
}

.viewSearch:active {
  background-color: #327e79;
}

.endDiv {
  height: 500px;
  background: white;
  padding: 15px;
  margin-bottom: 15px;
  box-shadow: 0px 3px 2px #aab2bd;
  box-sizing: border-box;
  color: #797979;
  font-family: "Ruda", sans-serif;
  font-size: 13px;
  box-shadow: 0px 3px 2px #aab2bd;
}

.searchQuestionContainer {
  background: #ffffff;
  padding: 15px;
  margin-bottom: 15px;
  box-sizing: border-box;
  color: #797979;
  font-family: "Ruda", sans-serif;
  font-size: 13px;
  box-shadow: 3px 3px 3px 3px #aab2bd;
  margin-left: 15%;
  margin-right: 15%;
}

.searchQuestionHeading {
  font-size: 18px;
  margin-top: 10px;
  margin-bottom: 10px;
  font-family: "Ruda", sans-serif;
  font-weight: 500;
  line-height: 1.1;
  color: inherit;
}

.searchQuestionSubContainer {
  display: flex;
  justify-content: left;
  flex-direction: row;
  margin-top: 5px;
  margin-bottom: 5px;
}

.searchQuestionDropdown {
  width: 100%;
  margin-bottom: 20px;
}

.searchQuestionSingleInput {
  width: 50%;
  display: flex;
}

.searchQuestionLabel {
  font-size: 16px;
  margin-top: 8px;
  margin-bottom: 5px;
  font-weight: 500;
  margin-right: 3%;
  width: 20%;
  margin-left: 9%;
  color: #797979;
  font-family: "Ruda", sans-serif;
}

.searchQuestionSelect {
  box-sizing: border-box;
  width: 52%;
  position: relative;
  max-height: 35px;
  padding-right: 15px;
  padding-left: 15px;
  color: #555;
  font-family: "Ruda", sans-serif;
  font-size: 13px;
  line-height: 1.42857143;
  margin-left: 4%;
  margin-right: 11%;
  border-radius: 4px;
  border: 1px solid #ccc;
  outline-color: #68dff0;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}

.viewdropdownDiv {
  display: flex;
  margin-bottom: 20px;
}

.viewImageContainer {
  height: 450px;
  display: flex;
  margin: 0 6%;
  justify-content: center;
  margin-bottom: 25px;
}
.viewQuestionDisplayDiv {
  height: 500px;
  overflow: auto;
}

.viewQuestionsBigImage {
  width: 100%;
  height: 440px;
  border-radius: 10px;
  margin-top: 25px;
}

.viewAddContainer {
  height: 80px;
  display: flex;
  margin: 0 5%;
  justify-content: center;
  margin-top: -30px;
}

.compulsoryContainerViewQuestions {
  background: #ffffff;
  padding: 15px;
  margin-bottom: 15px;
  box-sizing: border-box;
  color: #797979;
  font-family: "Ruda", sans-serif;
  font-size: 13px;
  box-shadow: 3px 3px 3px 3px #aab2bd;
}

.viewQuestionsSearchDisplay {
  display: flex;
}

.viewTablePagination {
  width: 54%;
}

.viewImageAbove {
  margin-bottom: -5px;
  margin-left: 5px;
}

.viewImageBelow {
  margin-top: 20px;
  width: 50%;
  flex-wrap: wrap;
}

.viewImageBelowTwo {
  margin-top: 0px;
  width: 50%;
  flex-wrap: wrap;
}

.viewImageBelowFile {
  margin-top: 20px;
  cursor: pointer;
  color: #1bc8e1;
  width: 50%;
  flex-wrap: wrap;
}

.viewResultRowDiv {
  display: flex;
  cursor: pointer;
  border-bottom: solid 1px #e5e5e5;
}

.viewResultRowDiv:active {
  background-color: #aab2bd;
}

.viewResultRowDivSel {
  display: flex;
  cursor: pointer;
  border-bottom: solid 1px #e5e5e5;
  background-color: #cae0ee;
}

.viewPublicIcon {
  margin-left: -2px;
  margin-top: 10px;
  color: #68dff0;
}

.viewByLastDiv {
  display: flex;
}

.viewShortDiv {
  margin-left: 20px;
}

.viewShortP {
  margin-bottom: 0px;
  font-size: 14px;
  font-weight: 700;
}

.viewBy {
  margin-left: 20px;
}

.viewByCurated {
  margin: -4px 0px 10px 38px;
}

.viewLastUpdated {
  margin-left: 25px;
}

.viewQuestionsH4RadioDiv {
  display: flex;
  flex-direction: row;
}

.viewQuestionsRadioDiv {
  margin: -15px 0px 0px 40px;
  display: flex;
}

.viewQuestionsRadioInput {
  margin-left: 20px;
}

.viewQuestionsRadioP {
  margin: 27px 0px 0px 5px;
}

.questionViewdropdownDiv {
  display: flex;
  margin-bottom: 12px;
}

.tableContainerViewQuestion {
  height: 480px;
  margin: 0 5%;
  margin-bottom: 20px;
  overflow-y: auto;
}

.veiwQuestionDisplayInfo {
  display: flex;
  flex-direction: row;
}

.ReuseButton {
  margin-left: 15px;
  max-height: 35px;
  margin-top: 45px;
  color: #f2f2f2;
  font-size: 12px;
  border-radius: 4px;
  border: none;
  padding: 8px 15px;
  background: #68dff0;
  cursor: pointer;
}

.ReuseButton:hover {
  background-color: #51cac2;
}
.ReuseButton:active {
  border: 1px solid #03afa9 !important;
}

.loadingBackground {
  position: fixed; /* Positioning and size */
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(128, 128, 128, 0.5);
  z-index: 99;
}`, "",{"version":3,"sources":["webpack://./src/components/Screens/ViewQuestions/viewQuestions.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,4CAA4C;EAC5C,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,sBAAsB;EACtB,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;AACf;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,+BAA+B;EAC/B,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,wEAAwE;AAC1E;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe,EAAE,yBAAyB;EAC1C,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,0CAA0C;EAC1C,WAAW;AACb","sourcesContent":[".viewH3 {\n  font-size: 24px;\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.1;\n  color: inherit;\n  margin-top: 70px;\n  margin-bottom: 20px;\n  color: #797979;\n}\n\n.viewH3 .viewH3Arrow {\n  font-size: 16px;\n}\n\n.viewContainer {\n  background: #ffffff;\n  padding: 15px;\n  margin-bottom: 15px;\n  box-sizing: border-box;\n  color: #797979;\n  font-family: \"Ruda\", sans-serif;\n  font-size: 13px;\n  box-shadow: 3px 3px 3px 3px #aab2bd;\n  margin-left: 15%;\n  margin-right: 15%;\n}\n\n.viewSearch {\n  color: #fff;\n  background-color: #68dff0;\n  box-shadow: inset 0 3px 5px rgb(0 0 0 / 13%);\n  padding: 6px 12px;\n  margin-bottom: 0;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1.42857143;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  border: 1px solid #48bcb4;\n  border-radius: 4px;\n  cursor: pointer;\n}\n.viewSearch:hover {\n  background-color: #51cac2;\n}\n\n.viewSearch:active {\n  background-color: #327e79;\n}\n\n.endDiv {\n  height: 500px;\n  background: white;\n  padding: 15px;\n  margin-bottom: 15px;\n  box-shadow: 0px 3px 2px #aab2bd;\n  box-sizing: border-box;\n  color: #797979;\n  font-family: \"Ruda\", sans-serif;\n  font-size: 13px;\n  box-shadow: 0px 3px 2px #aab2bd;\n}\n\n.searchQuestionContainer {\n  background: #ffffff;\n  padding: 15px;\n  margin-bottom: 15px;\n  box-sizing: border-box;\n  color: #797979;\n  font-family: \"Ruda\", sans-serif;\n  font-size: 13px;\n  box-shadow: 3px 3px 3px 3px #aab2bd;\n  margin-left: 15%;\n  margin-right: 15%;\n}\n\n.searchQuestionHeading {\n  font-size: 18px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  font-family: \"Ruda\", sans-serif;\n  font-weight: 500;\n  line-height: 1.1;\n  color: inherit;\n}\n\n.searchQuestionSubContainer {\n  display: flex;\n  justify-content: left;\n  flex-direction: row;\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n\n.searchQuestionDropdown {\n  width: 100%;\n  margin-bottom: 20px;\n}\n\n.searchQuestionSingleInput {\n  width: 50%;\n  display: flex;\n}\n\n.searchQuestionLabel {\n  font-size: 16px;\n  margin-top: 8px;\n  margin-bottom: 5px;\n  font-weight: 500;\n  margin-right: 3%;\n  width: 20%;\n  margin-left: 9%;\n  color: #797979;\n  font-family: \"Ruda\", sans-serif;\n}\n\n.searchQuestionSelect {\n  box-sizing: border-box;\n  width: 52%;\n  position: relative;\n  max-height: 35px;\n  padding-right: 15px;\n  padding-left: 15px;\n  color: #555;\n  font-family: \"Ruda\", sans-serif;\n  font-size: 13px;\n  line-height: 1.42857143;\n  margin-left: 4%;\n  margin-right: 11%;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  outline-color: #68dff0;\n  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\n}\n\n.viewdropdownDiv {\n  display: flex;\n  margin-bottom: 20px;\n}\n\n.viewImageContainer {\n  height: 450px;\n  display: flex;\n  margin: 0 6%;\n  justify-content: center;\n  margin-bottom: 25px;\n}\n.viewQuestionDisplayDiv {\n  height: 500px;\n  overflow: auto;\n}\n\n.viewQuestionsBigImage {\n  width: 100%;\n  height: 440px;\n  border-radius: 10px;\n  margin-top: 25px;\n}\n\n.viewAddContainer {\n  height: 80px;\n  display: flex;\n  margin: 0 5%;\n  justify-content: center;\n  margin-top: -30px;\n}\n\n.compulsoryContainerViewQuestions {\n  background: #ffffff;\n  padding: 15px;\n  margin-bottom: 15px;\n  box-sizing: border-box;\n  color: #797979;\n  font-family: \"Ruda\", sans-serif;\n  font-size: 13px;\n  box-shadow: 3px 3px 3px 3px #aab2bd;\n}\n\n.viewQuestionsSearchDisplay {\n  display: flex;\n}\n\n.viewTablePagination {\n  width: 54%;\n}\n\n.viewImageAbove {\n  margin-bottom: -5px;\n  margin-left: 5px;\n}\n\n.viewImageBelow {\n  margin-top: 20px;\n  width: 50%;\n  flex-wrap: wrap;\n}\n\n.viewImageBelowTwo {\n  margin-top: 0px;\n  width: 50%;\n  flex-wrap: wrap;\n}\n\n.viewImageBelowFile {\n  margin-top: 20px;\n  cursor: pointer;\n  color: #1bc8e1;\n  width: 50%;\n  flex-wrap: wrap;\n}\n\n.viewResultRowDiv {\n  display: flex;\n  cursor: pointer;\n  border-bottom: solid 1px #e5e5e5;\n}\n\n.viewResultRowDiv:active {\n  background-color: #aab2bd;\n}\n\n.viewResultRowDivSel {\n  display: flex;\n  cursor: pointer;\n  border-bottom: solid 1px #e5e5e5;\n  background-color: #cae0ee;\n}\n\n.viewPublicIcon {\n  margin-left: -2px;\n  margin-top: 10px;\n  color: #68dff0;\n}\n\n.viewByLastDiv {\n  display: flex;\n}\n\n.viewShortDiv {\n  margin-left: 20px;\n}\n\n.viewShortP {\n  margin-bottom: 0px;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.viewBy {\n  margin-left: 20px;\n}\n\n.viewByCurated {\n  margin: -4px 0px 10px 38px;\n}\n\n.viewLastUpdated {\n  margin-left: 25px;\n}\n\n.viewQuestionsH4RadioDiv {\n  display: flex;\n  flex-direction: row;\n}\n\n.viewQuestionsRadioDiv {\n  margin: -15px 0px 0px 40px;\n  display: flex;\n}\n\n.viewQuestionsRadioInput {\n  margin-left: 20px;\n}\n\n.viewQuestionsRadioP {\n  margin: 27px 0px 0px 5px;\n}\n\n.questionViewdropdownDiv {\n  display: flex;\n  margin-bottom: 12px;\n}\n\n.tableContainerViewQuestion {\n  height: 480px;\n  margin: 0 5%;\n  margin-bottom: 20px;\n  overflow-y: auto;\n}\n\n.veiwQuestionDisplayInfo {\n  display: flex;\n  flex-direction: row;\n}\n\n.ReuseButton {\n  margin-left: 15px;\n  max-height: 35px;\n  margin-top: 45px;\n  color: #f2f2f2;\n  font-size: 12px;\n  border-radius: 4px;\n  border: none;\n  padding: 8px 15px;\n  background: #68dff0;\n  cursor: pointer;\n}\n\n.ReuseButton:hover {\n  background-color: #51cac2;\n}\n.ReuseButton:active {\n  border: 1px solid #03afa9 !important;\n}\n\n.loadingBackground {\n  position: fixed; /* Positioning and size */\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(128, 128, 128, 0.5);\n  z-index: 99;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
